import Param from './param';
import Util from './module/libs/util';
import sliderManager from './module/libs/slider';
import effectManager from './module/effect';
import globalNavi from './module/global/globalNavi';
import smoothScrollManager from './module/scroll/scrollManager';
import MouseManager from './module/mouse/mouseManager';
import tabManager from './module/tab/manager';
import snsManager from './module/sns/manager';
import kvManager from './module/kv/manager';
import topManager from './page/top';
import spTurnDevice from './module/global/spTurnDevice';
import contactManager from './module/libs/contact';

const param = new Param();
const util = new Util();
let slider;
let effect;
let gNavi;
let scroll;
let mouse;
let sns;
let tab;
let kv;
let toppage;
let turnDevice = new spTurnDevice(Useragnt.mobile || Useragnt.tablet? "sp":"pc");
let contact;

// const stats = new Stats();
// stats.showPanel( 0 );
// document.body.appendChild( stats.dom );

let pageID = document.body.id;
let fpsRate = 0;
let executionType = "landing"; /* 実行タイミングの制御用 */
let _w = 0;
let _h = 0;
let _x = 0;
let _y = 0;
let _dir = '';
let _delta = '';
let _pjaxFlg = false;

//element
let _html = document.querySelector('html');
let _header = document.getElementById('l-header');
let _root = document.getElementById('l-root');
let _mouseEl = document.querySelector('.js__mouse-move');

/* ---------------------------------------------------

  -- render

 --------------------------------------------------- */

let render = function () {

    if(!requestAnimationFrame){
        setTimeout(() => {
            render;
        },1000/60);
    }else{
        requestAnimationFrame(render);
    }

    fpsRate = util.updateTimeRatio();

    //stats.begin();

    if(!scroll.status.comp&&gNavi.status.now!=="open"&&param.screenType === 'normal')
    scroll.move(fpsRate);

    _dir = scroll.dir;

    if(pageID === 'top'){
        if(scroll.status.comp){
            if(param.screenType === 'normal' && Useragnt.pc){
                mouse.set(fpsRate);
                kv.mouse(mouse.obj,mouse.para3d);
            }
            kv.render(fpsRate);
        }
    }
    // if(_mouseEl){
    //     mouse.set(fpsRate);
    //     if(scroll.status.start) mouse.move(mouse.obj,mouse.para3d);
    // }

    //stats.end();

}


/* ---------------------------------------------------

  -- common

 --------------------------------------------------- */


let common = function (type) {

    effect = new effectManager();
    gNavi = new globalNavi(pageID,param);
    scroll = new smoothScrollManager(param,effect,pageID);
    sns = new snsManager();
    scroll.status.comp = true;

    // if(_mouseEl) {
    //     mouse = new MouseManager(scroll);
    // }

    if(document.getElementsByClassName('js__slider').length > 0 != false){
        slider = new sliderManager();
    }

    switch(pageID){
        case "top":
            toppage = new topManager(effect);
            mouse = new MouseManager();
            kv = new kvManager(param,scroll,slider,gNavi);
        break;
        case "contact":
            contact = new contactManager();
        break;
    }

    if(type==="landing"){
        TweenMax.set(document.body,{opacity:1});
    }

    if(pageID !== 'top'){
        effect.lowlayer();
        //document.getElementById('c-search').classList.add("type-color");
    }

    setTimeout(() => {
        scroll.init();
        pageManager(pageID);
        resize();
        render();
    },'1e3');

    if(document.getElementById('c-tab') != null){
        tab = new tabManager(param,scroll);
        tab.init();
    }

    if(document.getElementsByClassName('c-btn').length > 0 != false){
        let _Btn = document.querySelectorAll(".c-btn");
        effect.Btn(_Btn,"set");
        if(Useragnt.mobile||Useragnt.tablet||param.displayType === 'sp') return;
        for(let i=0; _Btn.length>i; i++) {
            _Btn[i].addEventListener('mouseenter', () => {
                effect.Btn(_Btn[i],"on");
            }, false);
            _Btn[i].addEventListener('mouseleave', () => {
                effect.Btn(_Btn[i],"out");
            }, false);
        }
    }

}

let pageManager = function(type){

    switch(pageID){
        case "top":
            kv.init();
            setTimeout(() => {
                toppage.init();
            },1e3);
        break;
        case "contact":
            contact.init();
        break;
    }

    TweenMax.to(window, 0, {
        scrollTo : { y: 0, autoKill:false },
    });

    setTimeout(() => {
        if(pageID !== 'top'){
            _html.classList.remove('is-no-scroll');
            scroll.status.start = true;
        }
        sns.set();
    },'1e3');


}

let resize = function () {

    param.displayType = ( window.innerWidth>param.breakpoint )?"pc":"sp";

    _w = window.innerWidth;
    _h = window.innerHeight;

    if(document.getElementById('c-tab') != null) {
        tab.resize(_w, _h);
    }

    scroll.resize(_w,_h);
    gNavi.resize(_w,_h);

    if(pageID === 'top' && param.screenType === 'full'){
        kv.resize(_w,_h);
    }

    if (Useragnt.mobile || Useragnt.tablet) turnDevice.resize();
}


/* ---------------------------------------------------

  -- load

 --------------------------------------------------- */

window.addEventListener('DOMContentLoaded', function() {
    TweenLite.to(window, 0, {scrollTo:0});
    common("landing");
});

/* ---------------------------------------------------

  -- event

 --------------------------------------------------- */

/* scroll */
document.addEventListener('scroll', function(e) {

    if(_pjaxFlg) return;

    if(gNavi.status.now==="open" || !scroll.status.start){
        e.preventDefault();
        return;
    }else{
        _y = window.pageYOffset || document.documentElement.scrollTop;
        gNavi.update(_y);
        scroll.update(_y,"");
    }

}, {passive: false});

// let scrollEvent = function () {
//
//     if(!scroll.status.start || _pjaxFlg) return;
//
//     if(_dir === 'prev'){
//         _y = window.pageYOffset || document.documentElement.scrollTop;
//     }
//
// }

/* wheel */
// var MOUSE_WHEEL_EVENT = 'onwheel' in document ? 'wheel' : 'onmousewheel' in document ? 'mousewheel' : 'DOMMouseScroll';
// document[MOUSE_WHEEL_EVENT] = function (e) {
//
//     _delta = e.originalEvent.deltaY ? -(e.originalEvent.deltaY) : e.originalEvent.wheelDelta ? e.originalEvent.wheelDelta : -(e.originalEvent.detail);
//
//     if (_delta < 0){
//         _dir = 'next';
//         scrollEvent();
//     }else if (_delta > 0){
//         _dir = 'prev';
//         scrollEvent();
//     }
//
// };

/* [ SMP Tablet用 ]
 ------------------------------------*/

let touchInc = {
    x : 0,
    y : 0,
    pos : 0,
}

window.addEventListener("touchstart",function (e) {
    touchInc.x = e.touches[0].pageX;
    touchInc.y = e.touches[0].pageY;
});
window.addEventListener("touchmove",function (e) {
});
window.addEventListener("touchend",function (e) {

});



/* [ keyboard 用 ]
 ------------------------------------*/

document.addEventListener('keyup',function(e){

    if(e.keyCode == 40 || e.keyCode == 34 ){

        _dir = 'next';
        scrollEvent();

    }else if(e.keyCode == 38 || e.keyCode == 33){

        _dir = 'prev';
        scrollEvent();

    }

});

/* mouse event */
if(Useragnt.pc && pageID === 'top'){
    window.addEventListener("mousemove",function (e) {
        if(!scroll.status.comp || Useragnt.mobile || Useragnt.tablet || param.screenType === 'full') return;
        _x = e.clientX;
        _y = e.clientY;
        mouse.update(_x,_y);
    });
}

window.addEventListener('resize', resize, false);
window.addEventListener('onorientationchange', resize, false);